import { render, staticRenderFns } from "./BomDetailsSelectorModal.vue?vue&type=template&id=fc8519e2&scoped=true"
import script from "./BomDetailsSelectorModal.vue?vue&type=script&lang=js"
export * from "./BomDetailsSelectorModal.vue?vue&type=script&lang=js"
import style0 from "./BomDetailsSelectorModal.vue?vue&type=style&index=0&id=fc8519e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8519e2",
  null
  
)

export default component.exports